import React from "react";
// import {createRoot} from 'react-dom/client';
import ReactDOM from "react-dom";
import "./globals.scss";
import Routes from "./routes.js";
import "./lang/i18n.js";

// createRoot(document.getElementById('root')).render(<Ruoter />);

ReactDOM.render(
  <React.StrictMode>
    <Routes />
  </React.StrictMode>,
  document.getElementById("root")
);
